import { Icon, useTheme } from '../../../base';
import { StepIconRoot } from './CustomStepIcon.styles';

interface Props {
    isActive: boolean;
    isCompleted: boolean;
}

const CustomStepIcon = (props: Props) => {
    const { isActive, isCompleted } = props;
    const theme = useTheme();
    return (
        <StepIconRoot isCompleted={isCompleted}>
            {isCompleted ? (
                <Icon name="CheckRoundedIcon" size={24} />
            ) : (
                isActive && (
                    <div
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor: theme.palette.secondary.main,
                        }}
                    />
                )
            )}
        </StepIconRoot>
    );
};

export default CustomStepIcon;
